// extracted by mini-css-extract-plugin
export default {"custom-sizes":"Gx2vea","customSizes":"Gx2vea","text-input":"jGbHkw","textInput":"jGbHkw","separator":"KEf39L","submit":"rJZ1L0","inactive":"ZsZMRx"};